import { ChangeDetectorRef, Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { CookieService } from 'ngx-cookie-service';
// import { firstValueFrom } from 'rxjs';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';

import $, { get } from 'jquery';
import moment from 'moment';
import Swal from 'sweetalert2';
import { functionsGoals, obtenerTamMax, optencionPeriodos } from '../../../models/Cuestionarios/funciones';
import { ProjectsService } from '../../../services/proyectos/projects.service';
import { ExcelService } from '../../../services/excel/excel.service';
import { messages } from '../../funciones/mensajes';
import { MatMenuTrigger } from '@angular/material/menu';
import { FiltersM } from '../../../components/models';
import { GraphATService } from '../../../services/riesgo-credito/riesgos/graph/graph-at.service';
import { EvaluacionEntity, IndicadorEntity } from '../../funciones/AlertaTemprana';
import { GanttRow } from '../../../components/gantt/models/headers-type.model';

@Component({
  selector: 'app-seguimiento-planes',
  templateUrl: './seguimiento-planes.component.html',
  styleUrl: './seguimiento-planes.component.css'
})
export class SeguimientoPlanesComponent {
  Filters = FiltersM;
  /* variables */  
  public allocations = [];
  public allocationId = undefined;
  public dataOrdenado = [];
  public periodos = [];
  public responsibles = [];
  public aditionals = [];
  public viewTablero = false;
  public viewResponsables = [];
  public viewResponsablesActivity = [];
  public viewAllresponsibles = true;
  public viewAllresponsiblesActivity = true;

  public allocation = [];
  private answersSheet = [];
  public questionsForPlans = [];

  public prefix = '';
  public suffix = '';
  public miles = ',';
  public decimal = '.';
  public precicion = 0;
  public aling = '';

  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger;
  menuTopLeftPosition = { x: '0', y: '0' };
  private adDelete: any;

  proyects = [];
  activities: any[] = [];

  public estats = [
    {name: 'Reprogramada', check: true},
    {name: 'Cumplida', check: true},
    {name: 'Incumplida', check: true},
    {name: 'En proceso', check: true},
    {name: 'No iniciada', check: true},
  ];

  
  /*Obtención de datos consultas*/
  private indicadorEntity = new IndicadorEntity;
  private evaluacionEntity = new EvaluacionEntity;

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private service: ProjectsService,
    private excel: ExcelService,
    readonly cookieService: CookieService,
    private graphAtService: GraphATService,
  ){
    this.evaluacionEntity = new EvaluacionEntity;
    this.indicadorEntity = new IndicadorEntity;
    this.evaluacionEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.evaluacionEntity.Id_Institucion = Number(cookieService.get('idInstitucion'));
    this.indicadorEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.getData();
  }
  /* Escribir información */
  public printDate(date){
    return moment(date).format('MMM-YY')
  }
  /* obtener tabla */
  responsables = [
    'Jefatura de Riesgos',
    'Gerencia de Créditos',
    'Gerencia de Créditos',
    'Asesoría Legal / Contabilidad',
    'Comité de Créditos',
    'Gerencia Administrativa',
    'Gerencia General',
    'Gerencia Administrativa',
    'Contabilidad',
    'Gerencia Comercial',
    'Comité de Inversiones',
    'Gerencia Comercial / TI',
    'Gerencia Financiera',
    'Gerencia Comercial',
    'Contabilidad',
    'Gerencia Financiera',
    'Gerencia General',
    'Riesgos / Friedrich LATAM',
  ]
  indicadores = [];
  ganttRows = [];
  private async getData(){
    const data = await this.graphAtService.getDataIndicadores(this.evaluacionEntity.Id_Plantilla);
    const indicadores = data.filter(i => i.nivel === 3).map(e => {
      return {
        id: e.id,
        name: e.descripcion,
      }
    })
    this.indicadores = indicadores;
    this.responsibles =  [ ...new Set(
        this.responsables.map(f => f)
      )].map( (r, i) => {
        return {
          id: i,
          roleName: r
        }
      });

    this.proyects = this.getProyectos();

    this.proyects = this.proyects.filter(d => d.series.length !== 0);

    this.proyects.forEach(p => {
      p.goals = functionsGoals.getGoals( p.inicio, p.fin, p.id )
    });

    const startDay = moment.min(
      this.proyects
        .filter(s => s.inicio != null)
        .map(s => moment(s.inicio))
    );

    const endDay = moment.max(
      this.proyects
        .filter(s => s.fin != null)
        .map(s => moment(s.fin))
    );
    
    this.periodos = optencionPeriodos.getPeriodos(
      startDay.format('MM/DD/YYYY'),
      endDay.format('MM/DD/YYYY')
    );
    this.aditionals = this.proyects[0].adicionales;
    this.viewTablero = true;
    this.getShowProjects(true, true);
  }
  proyectos = [
    {
      ind: 'Indice de Morosidad', 
      acti: [
        {
          act: 'Diagnóstico de la cartera vencida por tramos de mora, agencia, producto y analista',
          res: 'Jefatura de Riesgos',
          ini: '03/11/2025',
          fin: '19/12/2025'
        },
        {
          act: 'Conformar unidad de cobranza con esquema de incentivos por recuperación',
          res: 'Gerencia de Créditos',
          ini: '05/01/2026',
          fin: '27/02/2026'
        },
        {
          act: 'Campaña de reestructuración y refinanciación para mora de 61 a 180 días',
          res: 'Gerencia de Créditos',
          ini: '02/02/2026',
          fin: '31/07/2026'
        },
        {
          act: 'Gestión judicial y castigo de cartera > 360 días conforme a la normativa del INCOOP',
          res: 'Asesoría Legal / Contabilidad',
          ini: '02/03/2026',
          fin: '30/09/2026'
        },
        {
          act: 'Actualizar la política de crédito (capacidad de pago, límites de endeudamiento y garantías)',
          res: 'Comité de Créditos',
          ini: '05/01/2026',
          fin: '30/04/2026'
        },
      ],
      name: 'Recuperación de cartera'
    },
    {
      ind: 'Indice de gastos administrativos',
      acti: [
        {
          act: 'Análisis detallado de los gastos de administración 2025 e identificación de partidas extraordinarias',
          res: 'Gerencia Administrativa',
          ini: '03/11/2025',
          fin: '15/12/2025'
        },
        {
          act: 'Presupuesto 2026 con techo de gastos de administración del 65% de los ingresos financieros',
          res: 'Gerencia General',
          ini: '01/12/2025',
          fin: '30/01/2026'
        },
        {
          act: 'Renegociar contratos de servicios (seguridad, enlaces de datos, alquileres)',
          res: 'Gerencia Administrativa',
          ini: '02/02/2026',
          fin: '30/06/2026'
        },
        {
          act: 'Tablero mensual de gastos por centro de costo',
          res: 'Contabilidad',
          ini: '02/03/2026',
          fin: '29/05/2026'
        },
      ],
      name: 'Eficiencia de gastos'
    },
    {
      ind: 'Participación de cartera',
      acti: [
        {
          act: 'Plan comercial de colocación con metas por agencia y oficial de crédito',
          res: 'Gerencia Comercial',
          ini: '01/12/2025',
          fin: '27/02/2026'
        },
        {
          act: 'Reasignar gradualmente el excedente de inversiones financieras hacia cartera de créditos',
          res: 'Comité de Inversiones',
          ini: '15/01/2026',
          fin: '30/10/2026'
        },
        {
          act: 'Lanzar dos productos: crédito MIPYME y consumo con débito automático',
          res: 'Gerencia Comercial / TI',
          ini: '02/02/2026',
          fin: '30/06/2026'
        },
      ],
      name: 'Colocación y productividad'
    },
    {
      ind: 'Costo financiero depositos a plazo fijo',
      acti: [
        {
          act: 'Revisar el tarifario de plazo fijo y escalonar tasas por plazo y monto',
          res: 'Gerencia Financiera',
          ini: '05/01/2026',
          fin: '31/03/2026'
        },
        {
          act: 'Campaña de captación de ahorro a la vista',
          res: 'Gerencia Comercial',
          ini: '01/04/2026',
          fin: '30/09/2026'
        },
      ],
      name: 'Costo de fondeo'
    },
    {
      ind: 'Rendimiento del Capital',
      acti: [
        {
          act: 'Analizar la recurrencia de los otros ingresos',
          res: 'Contabilidad',
          ini: '03/11/2025',
          fin: '19/12/2025'
        },
        {
          act: 'Proyección financiera 2026 sin ingresos extraordinarios',
          res: 'Gerencia Financiera',
          ini: '05/01/2026',
          fin: '27/02/2026'
        },
      ],
      name: 'Sostenibilidad del resultado'
    },
    {
      ind: 'Indice de gastos de gobernabilidad',
      acti: [
        {
          act: 'Comité mensual de seguimiento del plan con informe al Consejo de Administración',
          res: 'Gerencia General',
          ini: '03/11/2025',
          fin: '30/10/2026'
        },
        {
          act: 'Corregir los parámetros del semáforo en Aleema (solvencia, liquidez, morosidad, activos improductivos)',
          res: 'Riesgos / Friedrich LATAM',
          ini: '03/11/2025',
          fin: '30/01/2026'
        }
      ],
      name: 'Gobierno y seguimiento'
    },
  ]
  getProyectos(){
    const aux = this.proyectos.map(p =>{
      const i = this.indicadores.find(i => i.name === p.ind);
      return {
        nombre: p.name,
        id: i.id,
        responsable: '',
        inicio: null,
        dias: null,
        fin: null,
        expandido: true,
        series: p.acti.map( (a, j) => {
          const r = this.responsibles.find(re => re.roleName === a.res);
          const fecha1 = moment(a.ini, 'DD/MM/YYYY');
          const fecha2 = moment(a.fin, 'DD/MM/YYYY');
          const goals = functionsGoals.getGoals(
            fecha1.format('MM/DD/YYYY'),
            fecha2.format('MM/DD/YYYY'),
            `${i.id}-${j}`
          );
          const mitad = Math.ceil(goals.length);
          goals.slice(0, mitad).forEach(item => {
            const random = Math.random() * (1 - 0.6) + 0.6;
            item.executed = Number((item.planned*random).toFixed(2));
          });
          this.activities.push({
            id: `${i.id}-${i}`,
            nombre: a.act,
            inicio: fecha1,
            fin: fecha2,
            days: fecha2.diff(fecha1, 'days'),
            idProyect: i.id,
            goals: goals,
            responsable: r
          });
          return {
            id: `${i.id}-${i}`,
            nombre: a.act,
            inicio: fecha1,
            fin: fecha2,
            days: fecha2.diff(fecha1, 'days'),
            idProyect: i.id,
            goals: goals,
            responsable: r
          }
        }),
      }
    });

    aux.forEach( (p, j) => {
      if (p.series.length) {
        p.inicio = moment.min(
          p.series.map(s => moment(s.inicio))
        );

        p.fin = moment.max(
          p.series.map(s => moment(s.fin))
        );

        p.dias = p.fin.diff(p.inicio,'days');
      }
    });

    return aux;
  }
  private getShowProjects(calcRes?, calcResAct?){
    var aux = [];
    this.dataOrdenado = [];
    for(const proy of this.proyects){
      var auxAct = [];
      const ex = this.activities.filter(a => a.idProyect === proy.id);
      for(const act of ex){
        if(this.isVisible(act)){
          auxAct.push(act);       
        }
      }
      if(auxAct.length !== 0){
        var responsable = false;
        if(this.viewAllresponsibles){
          responsable = true;
        }else{
          const ex = this.viewResponsables.find(pl => pl.id === proy.responsable?.id);
          responsable = ex?.check??false;
        }
        
        if(responsable){
          aux.push(
            {...JSON.parse(JSON.stringify(proy)), activities: JSON.parse(JSON.stringify(auxAct))}
          );
        }
      }
    }
    this.dataOrdenado = aux;
    if(calcRes){
      var auxRes = [];
      this.dataOrdenado.forEach(p =>{
        const ex = auxRes.find( r => r.id === p.responsable?.id);
        if(!ex && p.responsable){
          auxRes.push({
            ...p.responsable,
            name: p.responsable.role_name,
            check: false,
          });
        }
      });

      this.viewResponsables = auxRes;
    }
    if(calcResAct){
      var auxResActi = [];
      this.dataOrdenado.forEach(p => {
        p.activities.forEach( a => {
          const ex = auxResActi.find( r => r.id === a.responsable?.id);
          if(!ex && a.responsable){
            auxResActi.push({
              ...a.responsable,
              name: a.responsable.role_name,
              check: false,
            });
          }
        });
      });
      this.viewResponsablesActivity = auxResActi;
    }


    this.previewProject();
  }
  /* Visibilidad actividades proyectos */
  public isVisible( item: any){
    const per = this.getPeriod();
    const p = moment(per, 'MMM-YY');
    
    const start = item.inicio;
    const end = item.fin;

    var periodo = false;

    if( p.isBetween(start, end, 'month', '[]') || ( !item.finalizada && end.isBefore(p) ) || (item.goals.find(p => p.periodo === per)) ){
      periodo = true;
    }

    // var responsable = false;
    // if(this.viewAllresponsiblesActivity){
    //   responsable = true;
    // }else{
    //   const ex = this.viewResponsablesActivity.find(pl => pl.id === item.responsable?.id);
    //   responsable = ex?.check??false;
    // }

    return periodo ;//&& responsable;
  }
  /* Optención de la meta */
  public getGoal(goals: any[]){
    const per = this.getPeriod();

    if( goals !== undefined && goals.length > 0 ){
      const ex = goals.find( c => c.periodo === per);
      if( ex !== undefined ){        
        return ex;
      }
    }
    const date = moment(per, 'MMM-YY')
    goals.push({
      planned: 100,
      executed: null,
      periodo: per,
      year: date.year(),
      month: date.month()+1,
      id: '',
      activitieId: goals[0].activitieId,
    });

    // this.previewProject();
  }
  /* Avance de metas */
  public async previewGoal(goals: any[], activitie){
    const g = this.getGoal(goals);

    let guardo = false, introdujo: any;
    introdujo = await Swal.fire({
      title: ''+ this.translate.instant('cues.planes-seguimiento.avance'),
      text: "",
      input: 'number',
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      inputValue: g !== undefined ? g.executed : '',
      confirmButtonText: this.translate.instant('acciones.acep'),
      cancelButtonText: this.translate.instant('acciones.cancel'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {

        if( Number(value) >= 100 && g.planned !== 100 ){
          return this.translate.instant('cues.planes-seguimiento.ingresar-avance');
        }
        if( Number(value) > 100 && g.planned === 100 ){
          return this.translate.instant('cues.planes-seguimiento.ingresar-avance-correcto');
        }
        if( Number(value) < 0 ){
          return this.translate.instant('cues.planes-seguimiento.ingresar-avance-positivo');
        }

        guardo = true;
        return '';
      }
    });

    if( guardo ){
      
      if(g.id !== ''){
        if(Number(introdujo.value) === 0){
          try{
            // const res = await firstValueFrom(
            //   this.service.deleteProgress(g.id)
            // );
            g.id = '';
            g.executed = null;
          }catch(error){
            Swal.close();
            messages.errorMessageGraph(error.error.message);
            return;
          }
        }else{
          try{
            g.executed = Number(introdujo.value);
            // const res = await firstValueFrom(
            //   this.service.patchProgress(g)
            // );
          }catch(error){
            Swal.close();
            messages.errorMessageGraph(error.error.message);
            return;
          }
        }
      }else{
        try{
          g.executed = Number(introdujo.value);
          // const prog = await firstValueFrom(
          //   this.service.postProgress(g)
          // );
          // g.id = prog['data'].id;
          g.id = '';
          const ex = this.activities.find(c => c.id === g.activitieId);
          const exGoal = ex.goals.find(m => m.periodo === g.periodo);
          if(!exGoal){
            ex.goals.push(g)
          }
        }catch(error){
          Swal.close();
          messages.errorMessageGraph(error.error.message);
        }
      }

      if(goals.find(g => g.executed === 100)){
        activitie.finalizada = true;
      }else{
        activitie.finalizada = false;
      }
      const f = this.activities.find(e => e.id === activitie.id);
      f.finalizada = activitie.finalizada;
      const m = activitie.goals.filter(m => m.id !== null);
      f.goals = m;

      this.previewProject();
    }
    
  }
  /* Avance de los proyectos */
  private previewProject(){
    const per = this.getPeriod();

    for(const p of this.dataOrdenado){
      var avance = 0;
      var actTot = 0;

      for(const a of p.activities){
        const g = this.getGoal(a.goals);
        if(!g) continue;
        avance += Number((g.executed * 100 / g.planned).toFixed(2));
        actTot ++;
      }

      const gP = this.getGoal(p.goals);
      if(gP){
        avance = Number( (avance / actTot).toFixed(2) );
        avance = Number( (avance * gP.planned / 100).toFixed(2) );
        
        gP.executed = avance;
      }
    }
  }
  /* Optención del periodo */
  private getPeriod(otro?){
    for(const p of this.periodos){
      for(const s of p.series){
        if( s.check ){
          if(otro){
            return `${s.me}-${s.an}`
          }
          return s.periodo;
        }
      }
    }
    return undefined;
  }
  /* Periodos */
  public writePeriods(periodo){
    const p = periodo.split('-');

    const m = this.translate.instant( 'filtros.'+p[0] );

    return m + '-' + p[1];
  }
  public changePeriods(periodo){
    this.periodos.forEach( p => {
      p.series.forEach( s => {
        if( s.periodo === periodo.periodo ){
          s.check = true;
        }else{
          s.check = false;
        }
      });
    });
    this.getShowProjects();
  }
  public changeResponsibles(responsible){
    this.viewAllresponsiblesActivity = true;
    if(responsible === 'consolidado'){
      this.viewAllresponsibles = !this.viewAllresponsibles;

      if(!this.viewAllresponsibles){
        var auxResActi = [];
        this.dataOrdenado.forEach(p => {
          p.activities.forEach( a => {
            const ex = auxResActi.find( r => r.id === a.responsable?.id);
            if(!ex && a.responsable){
              auxResActi.push({
                ...a.responsable,
                name: a.responsable.role_name,
                check: false,
              });
            }
          });
        });
        this.viewResponsablesActivity = auxResActi;
        return;
      }else{
        this.viewResponsables.forEach( r =>{
          r.check = false;
        });
      }
    }else{
      this.viewResponsables.forEach( r =>{
        r.id === responsible.id ? r.check = !r.check: '';
      });

      const c = this.viewResponsables.some( r => r.check === false);
      if(!c){
        this.viewAllresponsibles = true;
        this.viewResponsables.forEach( r =>{
          r.check = false;
        });
      }
    }
    this.getShowProjects(false, true);
  }
  public changeResponsiblesActivity(responsible){
    if(responsible === 'consolidado'){
      this.viewAllresponsiblesActivity = !this.viewAllresponsiblesActivity;

      if(!this.viewAllresponsiblesActivity){
        return;
      }else{
        this.viewResponsablesActivity.forEach( r =>{
          r.check = false;
        });
      }
    }else{
      this.viewResponsablesActivity.forEach( r =>{
        r.id === responsible.id ? r.check = !r.check: '';
      });

      const c = this.viewResponsablesActivity.some( r => r.check === false);
      if(!c){
        this.viewAllresponsiblesActivity = true;
        this.viewResponsablesActivity.forEach( r =>{
          r.check = false;
        });
      }
    }
    this.getShowProjects();
  }
  /** */
  borrarFiltro(){
    this.viewTablero = false;
    this.viewAllresponsibles = true;
    this.viewAllresponsiblesActivity = true;
    this.getData();
  }
  // Comentarios
  public getComent(ad, act){
    const per = this.getPeriod();
    const adit = act.aditional.find(c => c.name === ad.name && c.type === ad.type);
    const com = adit.coments.find( c => c.periodo === per);
    if(com){
      return com.coment;
    }
    
    return '';
  }
  // Archivos
  public excelExport(){
    var headers = [
      this.translate.instant('cues.planes-seguimiento.planes'),
      this.translate.instant('cues.planes-seguimiento.responsible'),
      this.translate.instant('cues.planes-seguimiento.inicio'),
      this.translate.instant('cues.planes-seguimiento.dias'),
      this.translate.instant('cues.planes-seguimiento.fin'),
      this.translate.instant('cues.planes-seguimiento.acumulado'),
    ];
    var data = [];
    var row = [];
    const array = this.getAllProyects();
    for(const p of array){
      row.push(p.name);
      row.push(p.responsable?.role_name??'');
      row.push(p.start_date);
      row.push(p.days);
      row.push(p.end_date);
      row.push('');
      data.push(row);
      row = [];
      for(const a of p.activities){
        row.push(`-${a.name}`);
        row.push(`${a.responsable?.role_name??''}`);
        row.push(a.start_date);
        row.push(a.days);
        row.push(a.end_date);
        row.push(a.acumulado);
        data.push(row);
        row = [];
      }
    }
    this.excel.generateTableSeguimientoPlanes(
      this.translate.instant(`menu.${this.dataService.moduleSelect}`),
      headers,
      data,
      this.translate.instant(`menu.${this.dataService.moduleSelect}`)
    );
  }
  private getAllProyects(){
    var array = [];

    for(const pr of this.proyects){
      const act = JSON.parse(JSON.stringify(this.activities.filter(a => a.idProyect === pr.id)));
      for(const a of act){
        const acum = Math.max(...a.goals.map( m => m.executed));
        a['acumulado'] = acum;
      }
      const p = {
        ...pr,
        activities: act
      }
      array.push(p)
    }

    return array;
  }
  /* Estatus */
  public getEstatus(item, col?){
    const g = this.getGoal(item.goals);

    if(!g) return '';
    if(g.executed === null){
      if(col){
        return '#C8C7C8'
      }
      return this.translate.instant('cues.planes-seguimiento.estatus-1');
    }

    const rend = Number( (g.executed*100/g.planned).toFixed(2) );
    if(rend <= 80){
      if(col){
        return '#FFD100'
      }
      return this.translate.instant('cues.planes-seguimiento.estatus-2');
    }
    if(rend >= 80 ){
      if(col){
        return '#72D54A'
      }
      return this.translate.instant('cues.planes-seguimiento.estatus-3');
    }

  }
  /* Acumulado */
  public getAcumulado(a){
    const per = moment(this.getPeriod(), 'MMM-YY');
    const metasFin = a.goals.filter(m => moment(m.periodo, 'MMM-YY').isSameOrBefore(per));
    return Math.max(...metasFin.map( m => m.executed));    
  }
  /** escribir adicionales */
  public writeAditional(additional, activitie, object?){
    const ex = activitie.adicionales.find(a => a.nombre === additional.nombre);
    const per =  moment(this.getPeriod('numeros'), 'MM-YYYY').format('YYYY-MM-DD');
    switch(additional.tipo){
      case 'TEXT':
        if(ex){
          const com = ex.comentarios.find(c => moment(c.date.split('T')[0]).format('YYYY-MM-DD') === per );
          if( object && com ){
            return com;
          }
          return com?.comentario;
        }        
        break;
      case 'FILE':
        if(ex){
          const fil = ex.archivos.find(c => moment(c.date.split('T')[0]).format('YYYY-MM-DD') === per );
          if( object && fil ){
            return fil;
          }
          return fil?.nombre;
        }    
        break;
    }
    return undefined;
  }
  public async editAditional(additional, activitie){
    var guardo = false;
    const configArray = {
      TEXT: {
        input: 'text',
        title: this.translate.instant('gestion.seguimiento.proy-estra.ingComen'),
        getValue: () => this.writeAditional(additional, activitie),
        validator: () => {
          guardo = true;
          return '';
        }
      },
      FILE: {
        input: 'file',
        title: this.translate.instant('gestion.seguimiento.proy-estra.selecArch'),
        getValue: () => this.writeAditional(additional, activitie),
        validator: (value) => {
          if (!value) {
            return this.translate.instant('gestion.seguimiento.proy-estra.datoInvalido');
          }
          guardo = true;
          return '';
        }
      }
    };

    const config = configArray[additional.tipo];

    if (config) {
      const introdujo = await Swal.fire({
        title: config.title,
        text: "",
        input: config.input,
        inputValue: config.getValue(),
        showCancelButton: true,
        confirmButtonColor: '#ff6b00',
        cancelButtonColor: '#B9B9BC',
        confirmButtonText: this.translate.instant('swal.acep'),
        cancelButtonText: this.translate.instant('swal.cerr'),
        inputValidator: config.validator,
        reverseButtons: true,
        customClass: {
          actions: 'aleema-swal-actions',
          confirmButton: 'aleema-swal-confirm',
          cancelButton: 'aleema-swal-cancel',
          input: 'aleema-swal-select'
        },
      });

      if(guardo){
        messages.messageSaving(this.translate.instant('acciones.guardando'),this.translate.instant('acciones.espera'));
        switch(additional.tipo){
          case 'TEXT':
            var per =  this.getPeriod('numeros');
            const com = this.writeAditional(additional, activitie, true);
            if(!com && introdujo.value !== ''){
              try{
                const addic = {
                  activityId: activitie.id,
                  additionalId: Number(additional.id),
                  comentario: introdujo.value,
                  date: moment(per, 'MM-YYYY').format('YYYY-MM-DD'),
                };
                const act = this.activities.find(a => a.id === activitie.id);
                const add = act.adicionales.find(a => a.nombre === additional.nombre);
                if(add){
                  add.comentarios.push({
                    // id: res['data'].comentarios[0].id,
                    id: '',
                    comentario: introdujo.value,
                    date: moment(per, 'MM-YYYY').toISOString(),
                  });
                }else{
                  const adicionalPush = {
                    id: '',
                    // id: res['data'].id,
                    nombre: additional.nombre,
                    tipo: additional.tipo.toLowerCase(),
                    monto: '',
                    comentarios: [
                      {
                        id: '',
                        // id: res['data'].comentarios[0].id,
                        comentario: introdujo.value,
                        date: moment(per, 'MM-YYYY').toISOString(),
                      }
                    ],
                  }
                  act.adicionales.push(adicionalPush)
                }
              }catch(err){
                Swal.close();
                messages.errorMessageGraph(err);
                return;
              }

            }else{
              try{
                const ac = this.activities.find(a => a.id === activitie.id);
                const comA = this.writeAditional(additional, ac, true);
                const ad = ac.adicionales.find(a => a.nombre === additional.nombre)
                comA.comentario = introdujo.value;
                // await firstValueFrom(this.service.patchAditionalActivityComentario(ad,comA));
              }catch(err){
                Swal.close();
                messages.errorMessageGraph(err);
                return;
              }

            }
            break;
          case 'FILE':
            const selectedFiles = introdujo.value;
            if( selectedFiles["size"] > obtenerTamMax.getPeso() ){
              messages.errorMessageGraph(obtenerTamMax.getTexto())
              this.editAditional(additional, activitie);
            }else{
              var per =  this.getPeriod('numeros');
              const fil = this.writeAditional(additional, activitie, true);
              const imageName = introdujo.value.name;
              if(!fil && introdujo.value !== ''){
                const addic = {
                  activityId: activitie.id,
                  additionalId: Number(additional.id),
                  file: selectedFiles,
                  date: moment(per, 'MM-YYYY').format('YYYY-MM-DD'),
                };
                // const res = await firstValueFrom(this.service.postAditionalActivity(addic));
                const act = this.activities.find(a => a.id === activitie.id);
                const add = act.adicionales.find(a => a.nombre === additional.nombre);
                if(add){
                  add.archivos.push({
                    id: '',
                    // id: res['data'].archivos[0].id,
                    nombre: imageName,
                    date: moment(per, 'MM-YYYY').toISOString(),
                    // s3key: res['data'].archivos[0].s3key,
                    // type: res['data'].archivos[0].type,
                  });
                }else{
                  const adicionalPush = {
                    id: '',
                    // id: res['data'].id,
                    nombre: additional.nombre,
                    tipo: additional.tipo.toLowerCase(),
                    monto: '',
                    // monto: res['data'].monto,
                    archivos: [
                      {
                        id: '',
                        // id: res['data'].archivos[0].id,
                        nombre: imageName,
                        date: moment(per, 'MM-YYYY').toISOString(),
                        // s3key: res['data'].archivos[0].s3key,
                        // type: res['data'].archivos[0].type,
                      }
                    ],
                  }
                  act.adicionales.push(adicionalPush)
                }
              }
            }
          break;
        }
        this.getShowProjects();
        Swal.close();
        messages.succesMessageGraph(this.translate.instant('acciones.exito'));
      }
    }
  }
  public async openFile(file){
    try{
      const fil = await this.service.getFile(file.s3key);
      const link = document.createElement('a');
      link.href = fil;
      link.download = `${file.name}`; // opcional: puedes poner nombre
      link.target = '_blank'; // por si el navegador lo bloquea
      link.click();
    }catch(err){
      Swal.close();
      messages.errorMessageGraph(err);
      return;
    }
    Swal.close();
    messages.succesMessageGraph(this.translate.instant('acciones.exito'));
  }
  public onContextMenu(event: MouseEvent, additional, activitie) {
    event.preventDefault();
    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';
    const ac = this.activities.find(a => a.id === activitie.id);
    const comA = this.writeAditional(additional, ac, true);
    const ad = ac.adicionales.find(a => a.nombre === additional.nombre)
    this.adDelete = { file: comA, adicional:  ad, activitie};
    this.matMenuTrigger.openMenu();
  }
  public async deleteArchivo(){
    messages.messageSaving(this.translate.instant('acciones.deleting-item'),this.translate.instant('acciones.espera'));
    try{
      // await firstValueFrom(this.service.deleteFile(this.adDelete.adicional, this.adDelete.file));
      const ac = this.activities.find(a => a.id === this.adDelete.activitie.id);
      const ad = ac.adicionales.find(a => a.nombre === this.adDelete.adicional.nombre)
      ad.archivos = ad.archivos.filter(f => f.id !== this.adDelete.file.id);
    }catch(err){
      Swal.close();
      messages.errorMessageGraph(err);
      return;
    }
    this.getShowProjects();
    Swal.close();
    messages.succesMessageGraph(this.translate.instant('acciones.exito-delete'));
  }
}
